import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils/classnameVariants';

interface GridProps extends HTMLAttributes<HTMLDivElement> {
  fullWidth?: true;
}

const Grid = forwardRef<HTMLDivElement, GridProps>(({ fullWidth, className, children, ...props }, ref) => {
  if (!children) return null;
  return (
    <div
      {...props}
      className={cn(
        'relative mx-auto grid w-full grid-cols-4 gap-4 sm:grid-cols-8 sm:gap-6',
        !fullWidth && 'max-w-grid px-4 sm:px-8',
        className,
      )}
      ref={ref}
    >
      {children}
    </div>
  );
});
Grid.displayName = 'Grid';

export default Grid;
